export default __webpack_public_path__ + "images/1I.418980a.png";